export default [
  { name: 'Schwarz', code: '#000000'},
  { name: 'Blau', code: '#153ac6'},
  { name: 'Gelb', code: '#dfbd20'}
]
